import { CoreExecutorResult, } from "../../core/index.js";
import { DataPsmExecutorResultFactory, loadDataPsmSchema, } from "./data-psm-executor-utils.js";
import { DataPsmClassReference } from "../model/index.js";
export async function executeDataPsmDeleteClassReference(reader, createNewIdentifier, operation) {
    const schema = await loadDataPsmSchema(reader);
    if (schema === null) {
        return DataPsmExecutorResultFactory.missingSchema();
    }
    const resourceToDelete = await reader.readResource(operation.dataPsmClassReference);
    if (!DataPsmClassReference.is(resourceToDelete)) {
        return CoreExecutorResult.createError(`Missing class '${operation.dataPsmClassReference}' to delete.`);
    }
    return CoreExecutorResult.createSuccess([], [
        {
            ...schema,
            dataPsmParts: removeValue(operation.dataPsmClassReference, schema.dataPsmParts),
        },
    ], [operation.dataPsmClassReference]);
}
function removeValue(valueToRemove, array) {
    return array.filter((value) => value !== valueToRemove);
}
//# sourceMappingURL=data-psm-delete-class-reference-executor.js.map